import { createFileRoute } from "@tanstack/react-router";
import { GCPCallback } from "../../../features/infrastructure/clouds";

// The GCP OAuth return (ui-spec §2.8): GET /clouds/google/callback redirects here with the code and state, which
// the page POSTs back under this session to complete the consent, or with the result alone.
export const Route = createFileRoute("/_authed/$org/infrastructure/cloudaccounts/new/gcp_/callback")({
  validateSearch: (s: Record<string, unknown>) => ({
    result: typeof s.result === "string" ? s.result : undefined,
    account: typeof s.account === "string" ? s.account : undefined,
    message: typeof s.message === "string" ? s.message : undefined,
    code: typeof s.code === "string" ? s.code : undefined,
    state: typeof s.state === "string" ? s.state : undefined,
  }),
  component: Page,
});

function Page() {
  const { org } = Route.useParams();
  return <GCPCallback org={org} search={Route.useSearch()} />;
}
